import { useBreakpoint } from 'hooks/useBreakpoint';
import { Layout } from 'components/Layout/Layout';
import { MobileLayout } from 'components/mobile/MobileLayout/MobileLayout';
import { ContactForm } from 'components/ContactForm/ContactForm';
import { useTranslation } from 'react-i18next';
import { ContactForm as ContactFormMobile } from 'components/mobile/ContactForm/ContactForm';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import styles from '../styles/pages/Contact.module.css';

export const Contact = () => {
  const { t } = useTranslation();
  const { isMobile } = useBreakpoint();

  return (
    <>
      {isMobile ? (
        <MobileLayout
          title={
            <div className={styles.titleWrapper}>
              <ThemeIcon icon="contact" alt="Contact" variant="inline" />
              {t('contact_label')}
            </div>
          }
        >
          <ContactFormMobile />
        </MobileLayout>
      ) : (
        <Layout whiteBg>
          <ContactForm />
        </Layout>
      )}
    </>
  );
};
